<template>
  <b-nav-item-dropdown no-caret right menu-class="dropdown-min-width user-accessibility accessibility">
    <template #button-content>
      <GlassIcon :color="isBlack ? '#1e1e1e' : '#ffffff'" />
    </template>

    <div class="mx-4 mt-2">
      <p class="mb-2">{{ $t('view') }}</p>

      <div class="d-flex align-items-center justify-content-between">
        <button
            v-for="(button, index) in viewButtons"
            :key="index"
            :class="`btn ${button.class}`"
            :title="button.title"
            @click="changeVariation(button.modeType)"
        >
          {{ button.text }}
        </button>
      </div>
    </div>

    <b-dropdown-divider></b-dropdown-divider>

    <div class="mx-4">
      <label for="font-size">{{ $t('font_size', { value: fontSize }) }}</label>
      <b-form-input
          v-model="fontSize"
          class="w-100"
          id="font-size"
          type="range"
          :step="5"
          :min="0"
          :max="100"
          @update="(value) => updateFont(value)"
      ></b-form-input>
    </div>

    <b-dropdown-divider></b-dropdown-divider>

    <div class="mx-4 mb-2">
      <label for="zoom">{{ $t('zoom', { value: zoom }) }}</label>
      <b-form-input
          v-model="zoom"
          class="w-100"
          id="zoom"
          type="range"
          :step="25"
          :min="0"
          :max="100"
          @update="(value) => updateZoom(value)"
      ></b-form-input>
    </div>

  </b-nav-item-dropdown>
</template>

<script>
import { VIEW_MODE } from '@/utils/constants';
import GlassIcon from '@/components/svg/GlassIcon';

export default {
  name: 'UserAccessibility',
  props: ['isBlack'],
  data: () => ({
    VIEW_MODE,
    fontSize: 0,
    zoom: 0,
    staticPropViewButtons: [
      {
        class: 'btn-primary me-4',
        text: 'A',
      },
      {
        class: 'btn-secondary',
        text: 'A',
      },
      {
        class: 'bg-dark text-white ms-4',
        text: 'A',
      },
    ],
  }),
  components: {
    GlassIcon,
  },
  computed: {
    viewButtons() {
      return this.staticPropViewButtons.map((button, index) => ({
        ...button,
        modeType: Object.keys(VIEW_MODE)[index],
      }));
    },
  },
  methods: {
    changeVariation(mode) {
      this.$store.dispatch('changeViewMode', mode);
    },
    updateZoom(value) {
      const zoomValue = 1 + Number(value) / 4 / 100;

      setTimeout(() => this.$store.dispatch('changeZoom', zoomValue), 500)
    },
    updateFont(value) {
      const inputValue = Number(value);
      const rangeCalculatedValue = inputValue * 6 / 100;
      const fontSize = 16 + rangeCalculatedValue;

      this.$store.dispatch('changeFontSize', fontSize);
    },
  },
};
</script>

<style scoped lang="scss"></style>